import React from "react";

import AnyaSidebarHistory from "./AnyaSideBarHistory";

export default function AnyaModalHistoryPanel({
    chatHistory,
    chatId,
    onDeleteConversation,
    onHistorySelected,
    showHistory,
}) {
    if (!showHistory) {
        return null;
    }

    return (
        <div className="anya-history-container">
            <AnyaSidebarHistory
                chatHistory={chatHistory}
                chatId={chatId}
                onHistorySelected={onHistorySelected}
                onDeleteConversation={onDeleteConversation}
            />
        </div>
    );
}
